module.exports = __webpack_public_path__ + "65f01347cbc81b9fe6caae9787d02296.png";